import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { AboutForm } from '../forms'
import { Dashboard } from '../layouts'

const styles = theme => ({
    //
})

class AboutsNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'About'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <AboutForm 
                    path="abouts"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(AboutsNew)
